import React, { useContext } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { ROUTES } from '../../constants/routes';
import { userHasFn, SUB_APPS } from '../../utils/rbac';
import SubAppHeaderActions from '../../components/SubAppHeaderActions';

const navClass = ({ isActive }) =>
  `nav-link ${isActive ? 'active fw-semibold' : ''}`;

function HurricaneLayout() {
  const { user } = useContext(AuthContext);
  const canAdmin = userHasFn(user, SUB_APPS.HURRICANE, 'admin');
  const canReports = userHasFn(user, SUB_APPS.HURRICANE, 'reports');

  return (
    <div className="container-fluid mt-3 px-3 app-shell-page sub-app-white-nav hurricane-app">
      <div className="card app-card bg-white mb-3">
        <div className="card-body py-3">
          <div className="app-layout-bar d-flex flex-wrap justify-content-between align-items-center gap-2 mb-0 pb-0">
            <h1 className="app-layout-title mb-0">Hurricane</h1>
            <SubAppHeaderActions
              subAppHomePath={ROUTES.HURRICANE}
              subAppHomeLabel="Hurricane"
              navButtonClassName="btn btn-sm bg-white text-dark border"
            />
          </div>

          <ul className="nav nav-tabs mb-0 mt-3">
            <li className="nav-item">
              <NavLink to={ROUTES.HURRICANE} end className={navClass}>
                Start report
              </NavLink>
            </li>
            {canReports && (
              <li className="nav-item">
                <NavLink to={ROUTES.HURRICANE_REPORTS} className={navClass}>
                  Reports
                </NavLink>
              </li>
            )}
            {canAdmin && (
              <li className="nav-item">
                <NavLink to={ROUTES.HURRICANE_ADMIN} className={navClass}>
                  Admin
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </div>

      <Outlet />
    </div>
  );
}

export default HurricaneLayout;
